(function () {
  if (window.__productBundleSaveBound) return;
  window.__productBundleSaveBound = true;

  function shouldOpenMiniCart() {
    if (!window.themeVariables || !window.themeVariables.settings) return true;
    if (window.themeVariables.settings.cartType !== 'drawer') return false;
    if (window.themeVariables.settings.pageType === 'cart') return false;
    return true;
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-bundle-save-atc]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

    const variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    event.preventDefault();
    btn.classList.add('is-loading');
    btn.disabled = true;

    let cartAddUrl = '/cart/add.js';
    if (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartAddUrl) {
      cartAddUrl = window.themeVariables.routes.cartAddUrl + '.js';
    } else if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      cartAddUrl = window.Shopify.routes.root + 'cart/add.js';
    }

    const payload = {
      id: variantId,
      quantity: 1,
      sections: ['mini-cart'],
      sections_url: window.location.pathname
    };

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || 'Could not add bundle to cart');
          return data;
        });
      })
      .then(function (addResponse) {
        const cartUrl =
          (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) ||
          '/cart';

        return fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (res) {
          return res.json().then(function (cartContent) {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cart: cartContent }
              })
            );

            cartContent.sections = addResponse.sections;

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart: shouldOpenMiniCart()
                }
              })
            );

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                bubbles: true,
                detail: { product: addResponse }
              })
            );
          });
        });
      })
      .catch(function (err) {
        console.error('[Bundle Save]', err.message);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
